import { useQuery } from 'react-query'
import useCacheKeys from '../../../hooks/use-cache-keys'
import useApi from '../../../hooks/use-api'

const useCourseEnrollees = ({
    courseId
}) => {
    const cacheKeys = useCacheKeys()
    const { api, url, endpoints, time } = useApi()
    const { data, isLoading } = useQuery(
        [cacheKeys.COURSES, courseId, 'enrollees'],
        () => api.get(url(endpoints.courseEnrollees, { courseId })),
        {
            enabled: Boolean(courseId),
            staleTime: time.HOUR,
            refetchInterval: time.MINUTE * 5,
            refetchIntervalInBackground: true,
        }
    )
    
    const enrollees = data || []

    return {
        isLoading,
        enrollees
    }
}

export default useCourseEnrollees
